export const siteConfig = {
  name: "17.cn一起草每日大赛",
  tagline: "每天竞技赢好礼",
  description: "17.cn一起草每日大赛是17.cn平台推出的每日竞技活动，玩家每天参与一起草每日大赛即可赢取丰厚奖励。与全国玩家同台竞技，展现你的实力！",
  url: "https://17.cn",
  logo: "17.cn",
};

export const categories = [
  { id: "rules", name: "赛事规则", slug: "rules", description: "了解每日大赛的详细赛制规则与评分标准" },
  { id: "guide", name: "参赛指南", slug: "guide", description: "手把手教你如何报名参加每日大赛" },
  { id: "prizes", name: "奖品详情", slug: "prizes", description: "查看每日大赛的丰厚奖品与奖励机制" },
  { id: "stories", name: "玩家故事", slug: "stories", description: "听听获奖玩家们的心路历程与经验分享" },
  { id: "news", name: "赛事资讯", slug: "news", description: "获取最新的赛事动态与活动公告" },
  { id: "tips", name: "竞技攻略", slug: "tips", description: "高手教你提升竞技水平的实用技巧" },
];

export const articles = [
  {
    id: 1,
    title: "2026年17.cn一起草每日大赛全新赛季正式开启",
    slug: "2026-new-season",
    category: "news",
    categoryName: "赛事资讯",
    excerpt: "2026年17.cn一起草每日大赛迎来全面升级，全新赛季带来更多惊喜奖励和更刺激的竞技体验。新赛季引入全新评分机制，让每一场比赛都充满悬念。",
    content: `2026年，17.cn一起草每日大赛迎来了全新的赛季！本赛季在赛制、奖励和玩法上都进行了全面升级，为全国玩家带来前所未有的竞技体验。

## 全新赛季亮点

### 1. 全新评分机制
本赛季引入了全新的AI智能评分系统，能够更精准地评估每位玩家的表现。评分维度从原来的3个扩展到了5个，包括创意度、完成度、技巧性、观赏性和人气值。

### 2. 奖励全面升级
每日冠军奖金提升至888元，周冠军更能获得5000元大奖。此外还有限量版周边、平台会员等丰厚奖励等你来拿。

### 3. 竞技玩法多样化
新增团队竞技模式和限时挑战赛，让竞技不再单调。你可以邀请好友组队参赛，也可以单人挑战极限。

## 参赛方式
只需登录17.cn平台，进入"每日大赛"专区，选择你感兴趣的项目即可开始竞技。每天都有不同的主题等你来挑战！

## 赛程安排
- 每日赛：每天0:00-23:59
- 周决赛：每周日20:00
- 月总决赛：每月最后一个周六19:00

快来加入我们，与全国玩家一起竞技吧！`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20competitive%20gaming%20platform%20event%20announcement%2C%20warm%20golden%20orange%20theme%2C%20modern%20digital%20stage%20with%20spotlights%2C%20trophy%20and%20crown%20silhouettes%2C%20clean%20minimal%20background%20with%20soft%20gradient%2C%20professional%20esports%20atmosphere%2C%20warm%20lighting%2C%20editorial%20photography%20style&width=800&height=450&seq=article-cover-01&orientation=landscape",
    author: "赛事组委会",
    date: "2026-08-01",
    readTime: "5分钟",
    tags: ["新赛季", "赛事公告", "奖励升级"],
  },
  {
    id: 2,
    title: "一起草每日大赛参赛完全指南：从注册到夺冠",
    slug: "complete-guide",
    category: "guide",
    categoryName: "参赛指南",
    excerpt: "新手玩家必看的17.cn一起草每日大赛参赛完全指南，详细介绍从账号注册到参赛夺冠的全流程，让你轻松上手快速竞技。",
    content: `想要参加17.cn一起草每日大赛但不知道从何开始？别担心，这篇完全指南将手把手教你如何从零开始，一步步成为竞技高手！

## 第一步：注册账号

1. 访问17.cn官网，点击右上角"注册"按钮
2. 填写手机号或邮箱，设置密码
3. 完成实名认证（必须步骤，确保公平竞技）
4. 设置你的竞技昵称和个人头像

## 第二步：了解赛制

17.cn一起草每日大赛采用积分制，每日竞技表现越出色，积分越高。积分可以在月末兑换丰厚奖励。

## 第三步：选择参赛项目

平台每天会推出不同主题的竞技项目，你可以根据自己擅长的领域选择参加。建议新手先从简单项目开始，逐步提升难度。

## 第四步：提交作品

在规定时间内完成竞技任务并提交。注意查看提交要求和截止时间，逾期将无法参与评选。

## 第五步：等待评选

作品提交后，系统会在次日公布评选结果。你可以在个人中心查看自己的排名和得分。

## 进阶技巧

- 多关注高分作品，学习他们的创作思路
- 参与平台社区讨论，与其他玩家交流经验
- 保持每天参赛的习惯，积累竞技经验
- 关注平台公告，及时了解赛制变化`,
    coverImage: "https://readdy.ai/api/search-image?query=Step%20by%20step%20guide%20illustration%20for%20online%20gaming%20competition%20registration%2C%20warm%20orange%20and%20gold%20color%20scheme%2C%20clean%20minimal%20design%20with%20numbered%20steps%2C%20modern%20digital%20interface%20elements%2C%20simple%20background%2C%20professional%20yet%20friendly%20style&width=800&height=450&seq=article-cover-02&orientation=landscape",
    author: "赛事小编",
    date: "2026-07-28",
    readTime: "8分钟",
    tags: ["新手入门", "参赛指南", "教程"],
  },
  {
    id: 3,
    title: "一起草每日大赛赛制规则详解：评分标准与晋级机制",
    slug: "competition-rules",
    category: "rules",
    categoryName: "赛事规则",
    excerpt: "深入了解17.cn一起草每日大赛的完整赛制规则，包括评分维度、晋级机制、违规处理等核心内容，确保你充分理解竞技规则。",
    content: `17.cn一起草每日大赛拥有一套完善的赛制规则体系，确保每一场比赛都公平公正。以下是详细的赛制规则说明。

## 一、基本赛制

### 每日赛
- 比赛时间：每天0:00至23:59
- 参赛方式：个人报名
- 评选时间：次日12:00公布结果
- 奖励：冠军888元、亚军388元、季军188元

### 周决赛
- 比赛时间：每周日20:00
- 参赛资格：当周每日赛积分前100名
- 奖励：冠军5000元、亚军2000元、季军1000元

### 月总决赛
- 比赛时间：每月最后一个周六19:00
- 参赛资格：当月周决赛积分前50名
- 奖励：冠军20000元、亚军8000元、季军3000元

## 二、评分标准

| 维度 | 权重 | 说明 |
|------|------|------|
| 创意度 | 30% | 作品的创新性和独特程度 |
| 完成度 | 25% | 作品的整体完成质量 |
| 技巧性 | 20% | 展现的技术水平和熟练度 |
| 观赏性 | 15% | 作品的视觉和审美价值 |
| 人气值 | 10% | 社区投票和互动数据 |

## 三、违规处理

1. 严禁使用外挂或作弊工具，一经发现永久封号
2. 禁止抄袭他人作品，违规者取消比赛资格
3. 禁止恶意刷票，违规票数清零并警告
4. 严重违规行为将追究法律责任`,
    coverImage: "https://readdy.ai/api/search-image?query=Professional%20competition%20rules%20and%20scoring%20system%20illustration%2C%20warm%20golden%20orange%20theme%2C%20clean%20infographic%20style%20with%20charts%20and%20icons%2C%20modern%20minimal%20design%2C%20soft%20gradient%20background%2C%20professional%20atmosphere&width=800&height=450&seq=article-cover-03&orientation=landscape",
    author: "赛事组委会",
    date: "2026-07-25",
    readTime: "6分钟",
    tags: ["赛制规则", "评分标准", "晋级机制"],
  },
  {
    id: 4,
    title: "一位普通玩家的夺冠之路：我在17.cn一起草每日大赛的故事",
    slug: "player-story-champion",
    category: "stories",
    categoryName: "玩家故事",
    excerpt: "来自广州的玩家小李分享他在17.cn一起草每日大赛中的真实经历，从默默无闻到月度总冠军的励志故事。",
    content: `大家好，我是小李，来自广州的一名普通上班族。今天想和大家分享我在17.cn一起草每日大赛中的真实经历。

## 初识每日大赛

三个月前，我在朋友的推荐下第一次接触到17.cn一起草每日大赛。起初只是抱着"随便玩玩"的心态参赛，没想到这一玩就上瘾了。

## 从失败中成长

刚开始参赛时，我的排名一直在百名开外。说实话，看着那些高手的作品，我确实有过放弃的念头。但我告诉自己：既然别人能做到，我也一定可以。

我开始认真研究每期高分作品的特点，学习他们的创作思路。每天晚上下班后，我都会花2-3个小时练习和创作。

## 第一次获奖

坚持了一个月后，我终于在每日赛中获得了季军！虽然只有188元奖金，但那种被认可的感觉让我激动不已。这给了我继续前进的动力。

## 月度总冠军

上个月，我以总积分第一的成绩获得了月度总冠军，拿到了20000元大奖！站在领奖台上的那一刻，所有的努力都值了。

## 我的心得

1. 坚持每天参赛，量变引起质变
2. 多向高手学习，但不盲目模仿
3. 找到自己的风格和优势领域
4. 保持良好心态，享受竞技过程

希望我的故事能给你一些启发。加油，下一个冠军就是你！`,
    coverImage: "https://readdy.ai/api/search-image?query=Inspiring%20story%20of%20a%20gaming%20competition%20winner%2C%20warm%20golden%20orange%20tone%2C%20person%20holding%20trophy%20in%20silhouette%20with%20soft%20spotlight%2C%20emotional%20and%20motivational%20atmosphere%2C%20clean%20modern%20composition%2C%20professional%20photography%20style&width=800&height=450&seq=article-cover-04&orientation=landscape",
    author: "玩家小李",
    date: "2026-07-20",
    readTime: "7分钟",
    tags: ["玩家故事", "夺冠经历", "心得分享"],
  },
  {
    id: 5,
    title: "一起草每日大赛新手必看：5个快速提升竞技水平的方法",
    slug: "beginner-tips",
    category: "tips",
    categoryName: "竞技攻略",
    excerpt: "17.cn一起草每日大赛新手入门攻略，分享5个经过验证的快速提升竞技水平的方法，帮助你在短时间内取得突破。",
    content: `刚加入17.cn一起草每日大赛的新手玩家，往往会感到无从下手。别担心！本文分享5个经过众多高手验证的提升方法，帮助你快速成长。

## 方法一：模仿学习法

找到最近一个月的高分作品，仔细分析它们的共同特点。可以从创意方向、结构布局、细节处理三个维度进行拆解。然后选择1-2个你喜欢的风格进行模仿练习。

## 方法二：刻意练习

不要盲目参赛。每次参赛前设定一个具体的练习目标，比如"今天我要提升创意度"或"这期我要优化完成度"。有针对性的练习比漫无目的的参与更有效。

## 方法三：时间管理

每日大赛的时间窗口是24小时，但并不意味着你要用满24小时。建议将创作时间控制在2-3小时内，这样可以保持高效和专注。

## 方法四：社区互动

积极参与17.cn社区讨论，不仅可以获得灵感，还能了解最新的评分趋势。有时候，其他玩家的一句点评就能让你豁然开朗。

## 方法五：定期复盘

每周花30分钟回顾自己这周的作品和排名变化。记录哪些策略有效，哪些需要改进。持续优化你的竞技策略。

坚持使用这5个方法，相信你很快就能看到进步！`,
    coverImage: "https://readdy.ai/api/search-image?query=Five%20essential%20tips%20for%20beginners%20in%20online%20gaming%20competition%2C%20warm%20orange%20and%20amber%20theme%2C%20clean%20numbered%20illustration%20with%20simple%20icons%2C%20modern%20flat%20design%2C%20friendly%20and%20encouraging%20atmosphere%2C%20minimal%20background&width=800&height=450&seq=article-cover-05&orientation=landscape",
    author: "赛事小编",
    date: "2026-07-18",
    readTime: "5分钟",
    tags: ["新手攻略", "技巧分享", "快速提升"],
  },
  {
    id: 6,
    title: "2026年Q3一起草每日大赛奖品清单公布",
    slug: "prizes-q3-2026",
    category: "prizes",
    categoryName: "奖品详情",
    excerpt: "17.cn一起草每日大赛2026年第三季度奖品清单正式公布，新增多款限量周边和高额现金奖励，快来一睹为快！",
    content: `17.cn一起草每日大赛2026年第三季度奖品清单正式公布啦！本赛季奖品全面升级，让我们一起来看看有哪些惊喜吧。

## 每日赛奖品

| 名次 | 奖品 |
|------|------|
| 冠军 | 现金888元 + 500平台积分 |
| 亚军 | 现金388元 + 300平台积分 |
| 季军 | 现金188元 + 200平台积分 |
| 4-10名 | 100平台积分 |
| 11-50名 | 50平台积分 |

## 周决赛奖品

| 名次 | 奖品 |
|------|------|
| 冠军 | 现金5000元 + 限量周边礼盒 |
| 亚军 | 现金2000元 + 定制周边 |
| 季军 | 现金1000元 + 平台会员年卡 |

## 月总决赛奖品

| 名次 | 奖品 |
|------|------|
| 冠军 | 现金20000元 + 冠军奖杯 + 全套限量周边 |
| 亚军 | 现金8000元 + 亚军奖杯 + 平台会员年卡 |
| 季军 | 现金3000元 + 季军奖杯 + 平台会员半年卡 |

## 新增限量周边

- 冠军定制T恤
- 专属竞技鼠标垫
- 纪念版手办
- 限定头像框和名片特效

平台积分可以在积分商城兑换各类虚拟道具和实物礼品。快来参赛赢取属于你的奖励吧！`,
    coverImage: "https://readdy.ai/api/search-image?query=Luxurious%20prize%20display%20with%20golden%20trophies%20and%20gift%20boxes%2C%20warm%20golden%20orange%20theme%2C%20elegant%20product%20photography%2C%20clean%20white%20background%20with%20soft%20shadows%2C%20premium%20award%20ceremony%20atmosphere%2C%20minimal%20composition&width=800&height=450&seq=article-cover-06&orientation=landscape",
    author: "赛事组委会",
    date: "2026-07-15",
    readTime: "4分钟",
    tags: ["奖品清单", "季度更新", "奖励详情"],
  },
];

export const faqs = [
  {
    question: "17.cn一起草每日大赛是什么？",
    answer: "17.cn一起草每日大赛是17.cn平台推出的每日竞技活动。玩家每天可以参与不同主题的竞技项目，通过创作和比拼赢取现金奖励和平台积分。比赛每天0:00开始，次日12:00公布结果。",
  },
  {
    question: "如何报名参加一起草每日大赛？",
    answer: '只需登录17.cn平台，完成实名认证后，进入「每日大赛」专区即可报名参赛。报名完全免费，每天都可以参加。新用户注册即可获得50平台积分作为参赛启动资金。',
  },
  {
    question: "参赛需要什么条件？",
    answer: "参赛条件很简单：年满18周岁、完成平台实名认证、拥有一个有效的17.cn账号。对技术水平没有硬性要求，无论你是新手还是老手，都可以参与竞技。",
  },
  {
    question: "奖金如何发放？",
    answer: '获奖后，奖金将在3个工作日内发放到你的平台账户。你可以在「我的钱包」中查看余额，支持提现到支付宝或银行卡。提现申请通常在1个工作日内处理完成。',
  },
  {
    question: "可以多次参赛吗？",
    answer: "每位玩家每天在每个竞技项目中只能提交一次作品，但你可以同时参加多个不同的竞技项目。周决赛和月总决赛需要满足相应的参赛资格才能报名。",
  },
  {
    question: "评分是如何进行的？",
    answer: "评分由AI智能评分系统和人工评审共同完成。评分维度包括创意度（30%）、完成度（25%）、技巧性（20%）、观赏性（15%）和人气值（10%）。人气值由社区玩家投票产生。",
  },
  {
    question: "如果我认为评分不公怎么办？",
    answer: '如果你对评分结果有异议，可以在结果公布后24小时内通过「申诉通道」提交申诉。申诉将由独立的评审委员会进行复核，复核结果在48小时内反馈。',
  },
  {
    question: "平台积分有什么用？",
    answer: '平台积分可以在积分商城兑换各类奖励，包括虚拟道具、平台会员、实物周边和限定头像框等。积分的有效期为获得之日起12个月，请及时使用。',
  },
];

export const prizes = [
  {
    id: 1,
    title: "每日冠军",
    prize: "888元现金 + 500积分",
    icon: "ri-trophy-line",
    color: "bg-amber-500",
  },
  {
    id: 2,
    title: "周冠军",
    prize: "5000元现金 + 限量周边",
    icon: "ri-medal-line",
    color: "bg-orange-500",
  },
  {
    id: 3,
    title: "月冠军",
    prize: "20000元现金 + 冠军奖杯",
    icon: "ri-vip-crown-line",
    color: "bg-red-500",
  },
  {
    id: 4,
    title: "参与奖励",
    prize: "50积分 + 抽奖机会",
    icon: "ri-gift-line",
    color: "bg-rose-400",
  },
];

export const highlights = [
  {
    id: 1,
    title: "每日新主题",
    description: "每天推出不同竞技主题，保持新鲜感和挑战性，让你每天都有新体验",
    icon: "ri-calendar-check-line",
  },
  {
    id: 2,
    title: "AI智能评分",
    description: "独创AI智能评分系统，结合多维度评估，确保评选结果公平公正",
    icon: "ri-robot-line",
  },
  {
    id: 3,
    title: "丰厚奖励",
    description: "每日、每周、每月多级奖励体系，冠军最高可获20000元现金大奖",
    icon: "ri-money-cny-circle-line",
  },
  {
    id: 4,
    title: "全国竞技",
    description: "与来自全国各地的玩家同台竞技，展示你的才华，结识志同道合的朋友",
    icon: "ri-group-line",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "小王",
    location: "北京",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Chinese%20man%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20friendly%20smile%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-wang&orientation=squarish",
    comment: "参加17.cn一起草每日大赛已经两个月了，不仅拿到了不少奖金，更重要的是认识了一群志同道合的朋友，每天都有动力创作！",
    rating: 5,
  },
  {
    id: 2,
    name: "小李",
    location: "广州",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Chinese%20woman%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20confident%20smile%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-li&orientation=squarish",
    comment: "从上个月开始认真参赛，终于拿到了月度总冠军！20000元奖金直接换了新电脑，感谢17.cn平台提供这么好的竞技机会！",
    rating: 5,
  },
  {
    id: 3,
    name: "老张",
    location: "上海",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20middle%20aged%20Chinese%20man%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20friendly%20expression%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-zhang&orientation=squarish",
    comment: "作为老玩家，见证了一起草每日大赛从起步到现在的成长。赛制越来越规范，奖励越来越丰厚，希望能一直办下去！",
    rating: 5,
  },
];

export const aboutInfo = {
  brandName: "17.cn一起草每日大赛",
  established: "2024年",
  users: "500万+",
  dailyParticipants: "10万+",
  totalPrizes: "5000万+",
  introduction: `17.cn一起草每日大赛是17.cn平台旗下最具影响力的每日竞技活动品牌。自2024年创办以来，我们始终秉持"公平竞技、快乐参与"的理念，为全国玩家打造一个展示才华、切磋技艺的优质平台。

我们相信每个人都有独特的创造力，而每日大赛就是让这份创造力发光发热的舞台。无论你是专业创作者还是业余爱好者，这里都有属于你的位置。

经过两年的发展，17.cn一起草每日大赛已经吸引了超过500万注册玩家，日均参赛人数突破10万人次，累计发放奖金超过5000万元。我们的赛事覆盖全国34个省级行政区，成为国内最具规模和影响力的每日竞技平台之一。`,
  mission: "让每一个人都能在竞技中找到快乐，在创作中实现价值。",
  values: [
    { title: "公平公正", description: "我们采用AI+人工双重评审机制，确保每一场比赛都公平公正" },
    { title: "创新进取", description: "持续优化赛制和玩法，为玩家带来更好的竞技体验" },
    { title: "用户至上", description: "以玩家需求为中心，不断改进产品和服务" },
    { title: "社区共建", description: "鼓励玩家之间的交流与互助，共建积极健康的竞技社区" },
  ],
  contact: {
    email: "support@17.cn",
    phone: "400-888-1717",
    wechat: "17cn_official",
    address: "北京市朝阳区建国路88号SOHO现代城A座17层",
    workingHours: "周一至周日 9:00-21:00",
  },
};